export default function Button({ children, url, ...props }) {
  return (
    <button href={url} className="button" {...props}>
      {children}
    </button>
  )
}
